
import React, { useState } from 'react';
import { NAMES, IMAGES } from '../constants';

interface OpeningCardProps {
  onOpen: () => void;
}

const OpeningCard: React.FC<OpeningCardProps> = ({ onOpen }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleStart = () => {
    setIsAnimating(true);
    // Transición más rápida y fluida
    setTimeout(onOpen, 800);
  };

  return (
    <div className={`fixed inset-0 z-[100] bg-cream flex items-center justify-center p-6 texture-paper transition-opacity duration-700 ${isAnimating ? 'opacity-0' : 'opacity-100'}`}>
      <div 
        onClick={handleStart}
        className={`relative w-[300px] h-[420px] rounded-[40px] shadow-[0_30px_60px_-15px_rgba(0,0,0,0.5)] cursor-pointer transition-all duration-700 transform flex flex-col items-center justify-center text-white text-center p-8 border border-white/20 overflow-hidden
        ${isAnimating ? 'scale-110' : 'scale-100'}`}
        style={{ 
          backgroundImage: `linear-gradient(rgba(85, 107, 47, 0.65), rgba(85, 107, 47, 0.65)), url(${IMAGES.envelope})`, 
          backgroundSize: 'cover', 
          backgroundPosition: 'center' 
        }}
      >
        {/* Textura sutil de papel en el sobre */}
        {/*<div className="absolute inset-0 opacity-20 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/pinstriped-suit.png')]"></div>*/}
        
        {/* Diseño de solapas minimalistas con líneas finas */}
        <div className="absolute top-0 left-0 right-0 h-1/2 border-b border-white/5 bg-black/5" style={{ clipPath: 'polygon(0 0, 100% 0, 50% 100%)' }}></div>
        
        <div className="relative z-10 flex flex-col items-center -mt-16">
            <p className="text-[10px] tracking-[0.5em] uppercase opacity-80 mb-4 -mt-10 font-bold text-white shadow-sm">Nuestra Boda</p>
            <h2 className="font-script text-5xl mb-2 text-white drop-shadow-lg">{NAMES.bride.split(' ')[0]}</h2>
            <span className="font-serif text-xl italic my-0 opacity-70">&</span>
            <h2 className="font-script text-5xl mb-12 text-white drop-shadow-lg">{NAMES.groom.split(' ')[0]}</h2>
            
            <div className="mt-12 w-8 h-px bg-white/40 mb-8"></div>
            
            <div className="text-[11px] tracking-[0.4em] font-bold opacity-90 uppercase text-white shadow-sm">
              18.04.2026
            </div>
        </div>

        {/* Indicador táctil */}
        <div className="absolute bottom-10 flex flex-col items-center gap-2">
          <div className="w-px h-8 bg-gradient-to-b from-transparent to-white/60 animate-bounce"></div>
          <span className="text-[8px] uppercase tracking-[0.4em] opacity-60 font-bold">Tocar para abrir</span>
        </div>
      </div>
    </div>
  );
};

export default OpeningCard;
